export default "__VITE_ASSET___YKJnf0j__"